module.exports = __webpack_public_path__ + "img/count_down_block_bg.8d1363c5.png";